import request from '@/utils/request'

// 通用请求方法
// get
export function getAction({ url, params, method = 'get' }) {
  return request({
    url,
    method,
    params
  })
}
// post
export function postAction({ url, data, method = 'post' }) {
  return request({
    url,
    method,
    data
  })
}
// 预留字段
export function getReserveFieldConfig(params) {
  return request({
    url: '/adminapi/set/reserve_field_config/modular_list',
    method: 'get',
    params
  })
}

// 快捷搜索列表
export function getQuickSearchList(params) {
  return request({
    url: '/adminapi/set/table_quick_search/list',
    method: 'get',
    params
  })
}
// 快捷搜索列表-添加
export function addQuickSearchList(data) {
  return request({
    url: '/adminapi/set/table_quick_search/add',
    method: 'post',
    data
  })
}
// 快捷搜索列表-删除
export function deleteQuickSearchList(params) {
  return request({
    url: '/adminapi/set/table_quick_search/delete',
    method: 'get',
    params
  })
}

// 表头信息
export function getTableHeaderInfo(params) {
  return request({
    url: '/adminapi/set/table_header/get_header',
    method: 'get',
    params
  })
}
// 表头信息-更新
export function updateTableHeaderInfo(data) {
  return request({
    url: '/adminapi/set/table_header/update',
    method: 'post',
    data
  })
}

// 导出导入列表
export function getExportAndImportList(params) {
  return request({
    url: '/adminapi/plan_task/list',
    method: 'get',
    params
  })
}
// 导出导入详情
export function getExportAndImportById(params) {
  return request({
    url: '/adminapi/plan_task/detail',
    method: 'get',
    params
  })
}
// 下载文件
export function downloadFileByType(params) {
  return request({
    url: '/adminapi/download',
    method: 'get',
    params
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter, method = 'get') {
  if (method === 'get') {
    return request({
      url: url,
      params: parameter,
      method: method,
      responseType: 'blob'
    })
  } else {
    return request({
      url: url,
      method: method,
      data: parameter,
      responseType: 'blob'
    })
  }
}

/**
 * 下载文件
 * @param url 文件路径
 * @param fileName 文件名
 * @param parameter
 * @returns {*}
 */
export function downloadFile(url, fileName, parameter) {
  return downFile(url, parameter).then((data) => {
    if (!data || data.size === 0) {
      this.$message.warning('文件下载失败')
      return
    }
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(new Blob([data]), fileName)
    } else {
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
      window.URL.revokeObjectURL(url) // 释放掉blob对象
    }
  })
}

/**
 * 级联获取地区列表
 * @param node
 * @param resolve
 * @returns {Promise<void>}
*/
export function getRegionList(node, resolve) {
  const params = {
    parent_id: node.level === 0 ? 1 : node.data.row_id
  }
  return getAction({ url: '/adminapi/set/region/select_list', params }).then(res => {
    if (res.status === 200) {
      const nodes = res.data.list.map(item => {
        return {
          value: item.reg_code,
          label: item.reg_fullname,
          row_id: item.row_id,
          leaf: node.level >= 2
        }
      })
      resolve(nodes)
    }
  })
}
